import { captureProfileGuard } from "../../lib/profileSession";
import type { ActivityTarget, ContractActivityDirection } from "../../lib/api-client/contractActivity";

export type ActivityPresentation = { direction: ContractActivityDirection; visibleDates: number; open: string | null | undefined;
  expanded: Record<string, number>; snapshot?: string; anchorId?: string; anchorTop?: number; scrollY?: number };
type ReturnEntry = { target: ActivityTarget; href: string; presentation: ActivityPresentation; assertCurrent: () => void };
// Bounded, tab-local presentation only: no events, names, documents or grants.
// A monotonic guard rejects an entry even after switching away and back.
const returns = new Map<string, ReturnEntry>();
export function saveActivityReturn(target: ActivityTarget, presentation: ActivityPresentation) {
  const token = crypto.randomUUID();
  const query = new URLSearchParams(window.location.search);
  query.set("tab", "activity"); query.set("activityReturn", token);
  returns.set(token, { target, presentation, href: `${window.location.pathname}?${query}`, assertCurrent: captureProfileGuard() });
  if (returns.size > 8) returns.delete(returns.keys().next().value!);
  return token;
}
export function activityReturn(token: string | null, target?: ActivityTarget) {
  if (!token) return null;
  const entry = returns.get(token);
  if (!entry || (target && (entry.target.kind !== target.kind || entry.target.id !== target.id))) return null;
  try { entry.assertCurrent(); return entry; }
  catch { returns.delete(token); return null; }
}
export function clearActivityReturn(token: string | null) { if (token) returns.delete(token); }
